<app-title-bar rootBreadCrumbs="['i18n.core.navigation.parking']" titleText="i18n.domain.device-interaction.title"></app-title-bar>
<div class="row">
  <div class="col-12 mb-2">
    <div class="header-wrapper d-flex align-items-center" [formGroup]="filterForm">
      <app-client-autocomplete [(selectedClient)]="selectedClient"
        class="client-autocomplete me-2"></app-client-autocomplete>
      @if (selectedClient) {
        <div>
          <ejs-dropdownlist id="zone-filter" [placeholder]="'i18n.domain.parker-registration.filter.zones' | translate"
            [dataSource]="zoneDropdownValues" [fields]="dropdownSettings" [showClearButton]="true"
            class="filter-element me-2" formControlName="zone"></ejs-dropdownlist>
        </div>
        <button class="btn btn-primary ms-auto reload-btn e-icon icon-renew" (click)="onRefresh()"></button>
      }
    </div>
  </div>
</div>
@if (selectedClient) {
  <div class="control-section">
    <ejs-grid #grid class="grid-no-filter grid-with-footer" width="100%" rowHeight="38" [dataSource]="data"
      [allowSorting]="true" [filterSettings]="filterSettings" [allowFiltering]="true" [allowPaging]="true"
      [pageSettings]="pageSettings" [searchSettings]="searchOptions" (dataBound)="dataBound($event)"
      (actionComplete)="actionComplete($event)" (actionBegin)="actionBegin($event)">
      <ng-template #toolbarTemplate let-data>
      </ng-template>
      <e-columns>
        <e-column field="id" [visible]="false" headerText="id" [isPrimaryKey]="true"></e-column>
        <e-column field="zone.name" headerText="{{'i18n.domain.device-interaction.grid.zone' | translate}}"
          clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="name" headerText="{{'i18n.domain.device-interaction.grid.device' | translate}}"
          clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="deviceType" headerText="{{'i18n.domain.device-interaction.grid.device-type' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            {{getDeviceType(data.deviceType) | translate}}
          </ng-template>
        </e-column>
        <e-column field="brand" headerText="{{'i18n.domain.device-interaction.grid.device-brand' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            {{getDeviceBrand(data.brand) | translate}}
          </ng-template>
        </e-column>
        <e-column field="currentDevicePosition" headerText="{{'i18n.domain.device-interaction.grid.position' | translate}}"
          type="string" clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="interaction" headerText="{{'i18n.domain.device-interaction.grid.interactions' | translate}}"
          [allowSorting]="false" clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            @for (command of data.supportedCommands; track command) {
              <ejs-tooltip [content]="command.commandDescription">
                <button class="btn btn-sm btn-primary me-2 my-auto" (click)="executeDeviceCommand(data.id, command, data.currentDevicePosition)">
                  {{command.command}}
                </button>
              </ejs-tooltip>
            }
            @if (data.currentDevicePosition === 'Pending') {
              <div class="spinner-wrapper d-flex align-items-center justify-content-center">
                <div class="spinner-border spinner text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            }
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
}
